import * as _ from 'lodash';
import { IProcessedProfile } from '@/components/profileDetail';
import { ClickPath } from '@/components/profileDetail/profileHeader/ctaButton/shared/clickPath.enum';
import { api, googleAnalytics, mixpanel } from '@/core';
import { platformTypeToAppType } from '@/core/application.service';
import { countryDic } from '@/core/country';
import { countriesWithReceiveEmail } from '@/core/country/countriesWithReceiveEmail';
import { buildUserFormikConfig, ILeadRequest } from '@/pages/profile';
import { LeadFormConfig } from '@/pages/profile/lead/leadForm/leadForm.config';
import { rootStore } from '@/stores';

export const buildLeadFormikConfig = () => {
  return buildUserFormikConfig({
    [LeadFormConfig.requirements.name]: '',
    [LeadFormConfig.receiveEmails.name]: false,
  });
};

export const showEmailConsentCheckbox = (countryId: string) => {
  return _.includes(countriesWithReceiveEmail, countryId);
};

export const submitLeadForm = (
  appProfileId: string,
  appProfileName: string,
  values: any,
) => {
  const data = Object.assign(_.clone(values), {
    appProfileId,
    appProfileName,
    country: countryDic[values.country].name,
    receiveEmails: showEmailConsentCheckbox(values.country)
      ? values.receiveEmails
      : null,
  }) as ILeadRequest;
  const endpoint = '/api/lead';
  return api.post<any>(`${endpoint}`, data, {
    useGlobalLoading: true,
    responseType: 'text',
  });
};

export const trackContactUsSubmitted = (
  profile: IProcessedProfile,
  isLogin: boolean,
) => {
  const brand = rootStore.compatibilitiesStore.getCompatibilityById(
    profile.brand,
  );

  const properties = {
    appId: profile.appId || '',
    profileId: profile._id,
    profileName: profile.appName,
    clickPath: isLogin ? ClickPath.CUSTOMER : ClickPath.GUEST,
    brandPartner: brand?.name || '',
    appName: profile.applicationName || '',
    appDisplayName: profile.applicationDisplayName || '',
    appType: platformTypeToAppType(profile.applicationType) || '',
  };

  mixpanel.trackContactUsSubmitted(properties);
  googleAnalytics.trackContactUsSubmitted(properties);
};
